import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { filterSlice } from './slices/filterSlice';
import { modelSlice } from './slices/modelSlice';
import { userSlice } from './slices/userSlice';

export const useStore = create(
  devtools(
    immer((...a) => ({
      ...filterSlice(...a),
      ...userSlice(...a),
      ...modelSlice(...a),
    })),
    {
      enabled: true,
      name: 'Global Store',
      store: 'Global',
    }
  )
);
